import React from 'react';
import { gameTypes } from '../data/GameTypes';
import { getGameTypeColors } from '../utils/gameTypeColors';

// Step 1 of the wizard for first-time creators - pick a game type. Mirrors
// the look of the dashboard's first-run "popular game" cards so the choice
// feels consistent with the rest of the studio.
//
// Layout: vertical list on mobile (single column, easy tap targets), 2-col
// grid on desktop where there's horizontal space to use.
export default function WizardGameType({ selectedTypeId, onSelect }) {
    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2.5 lg:gap-4">
            {gameTypes.map((type) => {
                const isSelected = selectedTypeId === type.id;
                const iconColors = getGameTypeColors(type.id);
                return (
                    <button
                        key={type.id}
                        type="button"
                        onClick={() => onSelect(type.id)}
                        // hover styles removed - iOS Safari ghost-tap quirk.
                        // No transition either: instant visual feedback on
                        // tap so it doesn't feel laggy on mobile.
                        // Mobile: compact horizontal row. Desktop: tall visual
                        // tile so cards feel substantial against the phone
                        // preview rather than getting lost.
                        className={`w-full text-left rounded-lg p-3 lg:p-6 flex items-center lg:flex-col lg:items-start lg:justify-start gap-3 lg:gap-4 lg:min-h-[180px] border ${
                            isSelected
                                ? 'border-[var(--admin-accent)] bg-[var(--admin-accent)]/[0.08]'
                                : 'border-[var(--admin-border)] active:bg-white/5 lg:hover:border-white/30 lg:hover:bg-white/[0.03]'
                        }`}
                        aria-pressed={isSelected}
                    >
                        <div
                            className="p-2 lg:p-3 rounded-md lg:rounded-lg shrink-0"
                            // Color goes on the wrapper because the game-type
                            // icon components only forward className; their
                            // FontAwesome SVG inherits via currentColor.
                            style={{
                                background: iconColors?.bg,
                                border: `1px solid ${iconColors?.border}`,
                                color: iconColors?.icon,
                            }}
                        >
                            <type.icon className="w-5 h-5 lg:w-8 lg:h-8" />
                        </div>
                        <div className="min-w-0 flex-1 lg:flex-initial">
                            <p className="text-sm lg:text-base font-bold gch-text-primary leading-tight">{type.name}</p>
                            <p className="text-xs lg:text-[13px] gch-text-secondary leading-snug mt-0.5 lg:mt-1 line-clamp-2">
                                {type.description}
                            </p>
                        </div>
                    </button>
                );
            })}
        </div>
    );
}
